import { LucideIconData } from 'lucide-angular';

export const PoolCaC10: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M8 11 L9 8 H15 L16 11 Z' }],
  ['rect', { x: '6', y: '11', width: '12', height: '3', rx: '1' }],
  ['path', { d: 'M8 14 V16' }],
  ['path', { d: 'M16 14 V16' }],
];
